document.addEventListener('DOMContentLoaded', function () {
  // Wait for Shopify's variant selector to initialize
  setTimeout(function () {
    const sizeSelect = document.querySelector('select[name^="options["][name$="Size]"]');

    if (sizeSelect) {
      const desiredOption = Array.from(sizeSelect.options).find(option =>
        option.text.trim().toLowerCase().includes("12x18")
      );

      if (desiredOption && sizeSelect.value !== desiredOption.value) {
        sizeSelect.value = desiredOption.value;
        sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }, 100); // slight delay ensures elements are rendered
});